import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import ConfirmModal from 'components/modal/ConfirmModal/ConfirmModal'

import messages from './messages'


export default class LeavePaymentModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    name: constants.modals.LeavePayment,
    title: messages.title,
  }

  handleStay = () => {
    this.close()
  }

  onLeave = () => {
    const { data: { onLeave, nextLocation } } = this.props

    this.close()

    if (typeof onLeave === 'function') {
      onLeave(nextLocation.pathname)
    }
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ConfirmModal
        name={name}
        title={title}
        id={name}
        confirmTitle={messages.stayButton}
        cancelTitle={messages.leaveButton}
        onConfirm={this.handleStay}
        onCancel={this.onLeave}
        withTextCancel
      >
        <FormattedMessage {...messages.text} />
      </ConfirmModal>
    )
  }
}
